import React, { useState, useEffect } from "react";
import { LANDING_PAGE_URL } from "../../../../constant";
import "./styles.scss";
import { Form, Tooltip } from "antd";
import { BeatLoader } from "react-spinners";
import { PremiumLayoutSkeleton } from "../../../../components/page-skeleton";
import { CheckCircle, ContentCopyOutlined } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import http from "../../../../services/http";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";

function ApiKeyGenerator() {
  // STATES
  const [isCopied, setCopied] = useState(false);
  const [pageLoader, setPageLoader] = useState(true);
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [token, setToken] = useState("");

  // CONST VALS
  const [form] = Form.useForm();
  const params = useParams();

  // HANDLERS
  const copyHander = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const handleSubmit = (values) => {
    setLoading(true);
    http
      .post("api-access", {
        secret_key: params.token,
        access_code: values.code?.toUpperCase(),
      })
      .then((res) => {
        setLoading(false);
        setToken(res.data.api_key);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response.data.error ?? "Something went wrong");
      });
  };

  // HOOKS
  useEffect(() => {
    if (params.token) {
      http
        .get(`api-access?access_key=${params.token}`)
        .then((res) => {
          setPageLoader(false);
        })
        .catch((err) => {
          setError(err.response.data.error ?? "Something went wrong");
          setPageLoader(false);
        });
    } else {
      setPageLoader(false);
      setError("Invalid request");
    }
  }, [params]);

  return (
    <div className="apikey-generator">
      {pageLoader ? (
        <div className="loader-container">
          <PremiumLayoutSkeleton />
        </div>
      ) : error ? (
        <p className="error-container">{error}</p>
      ) : (
        <>
          <div className="logo logo-nav">
            <a
              href={LANDING_PAGE_URL}
              referrerPolicy="no-referrer"
              style={{ color: "rgba(0, 0, 0, 0.85)" }}
            >
              Conceptor
            </a>
          </div>
          <div className="form-container">
            <h2>{token ? "Your API Key" : "API Key Generator"}</h2>
            <p>
              {token
                ? "Keep your API key confidential. Do not share it or expose it in client-side code."
                : "Enter your 8-digit code sent to your email to generate your API key."}
            </p>
            {token && (
              <div className="api-key">
                <p>{token}</p>{" "}
                <Tooltip title={isCopied ? "Copied" : "Copy"}>
                  <CopyToClipboard text={token} onCopy={copyHander}>
                    <span onClick={copyHander}>
                      {isCopied ? <CheckCircle /> : <ContentCopyOutlined />}
                    </span>
                  </CopyToClipboard>
                </Tooltip>
              </div>
            )}
            {!token && (
              <Form onFinish={handleSubmit} form={form}>
                <Form.Item
                  name="code"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your 8-digit code",
                    },
                    { len: 8, message: "Please enter an 8-digit code" },
                  ]}
                >
                  <input type="text" placeholder="Enter your 8-digit code" />
                </Form.Item>
                <button type="submit">
                  {isLoading ? (
                    <BeatLoader color="#fff" size={10} />
                  ) : (
                    "Generate API Key"
                  )}{" "}
                </button>
              </Form>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ApiKeyGenerator;
